import logo from './Natwest.svg';

const NatwestLogo = () => {
    return <img src={logo} alt="Natwest logo" />;
};

NatwestLogo.borderColor = '#ffffff';
NatwestLogo.textColor = '#ffffff';
NatwestLogo.backgroundColor = '#281D46';

// eslint-disable-next-line import/no-default-export
export default NatwestLogo;
